import styled from 'styled-components';

const Input = styled.input.attrs({ type: 'checkbox' })`
  margin-right: 10px;
  accent-color: ${({ theme }) => theme.color.primary};
`;

export { Input };
